import { FeatureFlag } from './types';

/*

  Features are simply instances of type FeatureFlag.
  Add features as required.

  Features must be included in the FEATURE_FLAGS object below.

*/

export const RISK_SCORES: FeatureFlag = {
  local: true,
  dev: true,
  test: true,
  stage: true,
  prod: false,
};

export const LA_PATH_HIGHLIGHT: FeatureFlag = {
  local: false,
  dev: false,
  test: false,
  stage: false,
  prod: false,
};

export const FEATURE_FLAGS = {
  RISK_SCORES,
  LA_PATH_HIGHLIGHT,
} as const;
